import * as PIXI from "pixi.js"
import rgbHex from 'rgb-hex';

export default class Background extends PIXI.Container
{
    constructor (texture, strColor)
    {
        super();

        this.bgTexture = texture;
        this.color = strColor;

        this.build();
    }

    get color ()
    {
        return this.strColor;
    }

    set color (strColor)
    {
        this.setColor ( strColor );
    }

    build ()
    {
        this.gfxColor = new PIXI.Graphics();
        this.gfxColor.beginFill(0xFFFFFF, 1);
        this.gfxColor.drawRect(0, 0, window.innerWidth, window.innerHeight);
        this.gfxColor.endFill();
        this.gfxColor.tint = this.color;
        this.addChild(this.gfxColor);

        this.sprite = new PIXI.Sprite(this.bgTexture );
        this.addChild(this.sprite);

        this.sprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;
    }

    setColor (strColor)
    {
        if (strColor.indexOf("rgb") > -1)
        {
            strColor = "#" + rgbHex(strColor);

            if (strColor.length > 7)
            {
                strColor = strColor.substr(0,7);
            }
        }

        this.strColor = strColor;
        this.iColor = parseInt(strColor.substr(1), 16);

        if (this.gfxColor)
        {
            this.gfxColor.tint = this.iColor;
        }
    }
}
